import _ from "lodash";
import React, { useContext } from "react";
import Select, { createFilter } from "react-select";
import { VariantContextData } from "../variants/VariantBuilderContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MultiValueRemove = (props) => {
  return (
    <div
      className="custom-multivalue-remove"
      style={{ display: "flex", alignItems: "center" }}
    >
      {props.onEditItem && (
        <span
          className="px-[4px] hover:bg-slate-100 dark:hover:bg-slate-800 rounded-md h-full w-[20px] flex items-center justify-center"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={() => {
            props.onEditItem(props.data);
          }}
          tabIndex={-1}
          aria-label="Edit"
          role="button"
        >
          <FontAwesomeIcon icon={["fa-solid", "pencil"]} size="xs" />
        </span>
      )}

      <span
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={(e) => {
          props.innerProps.onClick(e);
        }}
        className="px-[4px] hover:bg-slate-100 dark:hover:bg-slate-800 rounded-md h-full w-[20px] flex items-center justify-center"
        tabIndex={-1}
        aria-label="Remove"
        role="button"
      >
        <FontAwesomeIcon icon={["fa-solid", "xmark"]} />
      </span>
    </div>
  );
};

const VariantBuilderSettingSelect = (props) => {
  const [contextData, builder] = useContext(VariantContextData);

  let options = props.options;

  if (options[0] && options[0].text) {
    options = props.options
      .filter((e) => e.condition !== false)
      .map((option) => {
        return { value: option.value, label: option.text, icon: option.icon };
      });
  }

  const selectedOptions =
    props.multi_select !== true && options && options.length > 0
      ? options[0].options
        ? options
            .filter((option) => option.options)
            .flatMap((option) => option.options)
            .filter((option) => option.value === props.value)
        : options.find((option) => option.value === props.value)
      : props.multi_select !== true
      ? ""
      : undefined;

  const multiSelectedOptions =
    props.multi_select == true && options && options.length > 0
      ? options[0].options
        ? options
            .filter((option) => option.options)
            .flatMap((option) => option.options)
            .filter(
              (option) =>
                option.value && props.value?.split(",")?.includes(option.value)
            )
        : options.filter(
            (option) =>
              option.value && props.value?.split(",")?.includes(option.value)
          )
      : undefined;

  const formatOptionLabel = ({ value, label, icon: optionIcon }) => {
    const isFontDropdown = props?.setting_name?.indexOf("font") > -1;
    let icon = optionIcon;

    if (!icon) {
      props.options.forEach((option) => {
        if (option.options) {
          const selectedOption = option.options.filter(
            (nested) => nested.value == value
          )[0];

          if (selectedOption && selectedOption.icon) {
            icon = selectedOption.icon;
          }
        } else if (option.value == value && option.icon) {
          icon = option.icon;
        }
      });
    }

    return (
      <div
        data-value={value}
        className="flex items-center"
        style={{
          fontFamily: isFontDropdown ? `${value}, Inter, san-serif` : null,
        }}
        onMouseOver={() => {
          if (isFontDropdown) {
            ctas.builder.fonts.load_font_family(value);
          }
        }}
      >
        {icon && (
          <img
            className="w-[13px] h-[13px] mr-5 object-contain"
            src={icon}
            alt=""
          />
        )}
        {label}
      </div>
    );
  };

  return (
    <React.Fragment>
      <Select
        classNames={{
          control: () =>
            "setting-select w-full !min-h-[34px] px-3 bg-white dark:bg-slate-950 text-xl text-black dark:text-white !rounded-xl border-solid border-[1px] !border-slate-200 dark:!border-slate-700 focus:!border-slate-200 !outline-none !shadow-none",
          dropdownIndicator: () => "!p-[0px]",
          indicatorSeparator: () => "!w-[0px]",
          input: () =>
            "text-black dark:text-white outline-none focus:outline-none focus:ring-0 appearance-none shadow-none",
          menu: () =>
            "w-full !z-50 bg-white dark:bg-slate-950 text-xl text-black dark:text-white rounded-xl border-solid border-[1px] border-slate-200 dark:border-slate-700",
          option: ({ isFocused, isSelected, isDisabled }) =>
            `!cursor-pointer !text-black dark:!text-white ${
              isSelected
                ? "!bg-blue-600 !text-white"
                : isFocused
                ? "!bg-slate-100 dark:!bg-slate-800"
                : isDisabled
                ? "!opacity-60" // Apply opacity 0.6 to disabled options
                : ""
            } hover:!text-black active:!text-black focus:!text-black hover:!bg-slate-100 active:!bg-slate-100 focus:!bg-slate-800 dark:hover:!text-white dark:active:!text-white dark:focus:!text-white dark:hover:!bg-slate-800 dark:active:!bg-slate-800 dark:focus:!bg-slate-800`,
          singleValue: () => "text-black dark:text-white",
          multiValue: () =>
            "select-multi-value !bg-white dark:!bg-slate-950 border-solid border-[1px] !border-slate-200 dark:!border-slate-700",
          multiValueLabel: () =>
            "cf-select-multi-value-label !whitespace-normal break-words",
          valueContainer: () => "!p-[0px] cf-select-container",
          menuPortal: () => (contextData.dark_mode ? "dark" : ""),
        }}
        menuPortalTarget={props.menu_portal ? document.body : undefined}
        styles={
          props.menu_portal
            ? { menuPortal: (base) => ({ ...base, zIndex: 2000 }) }
            : undefined
        }
        filterOption={createFilter({ ignoreAccents: false })}
        options={options}
        value={selectedOptions || multiSelectedOptions}
        defaultValue={multiSelectedOptions}
        placeholder={props.placeholder}
        isMulti={props.multi_select == true ? true : null}
        formatOptionLabel={formatOptionLabel}
        isLoading={props.isLoading}
        onInputChange={props.onInputChange}
        onFocus={props.onFocus}
        components={{
          MultiValueRemove: (multiValueRemoveProps) => (
            <MultiValueRemove {...multiValueRemoveProps} {...props} />
          ),
        }}
        onChange={(selectedOption) => {
          let old_value = _.get(
            contextData,
            "[objects][variant][" +
              props.object_type +
              "][" +
              props.object_id +
              "]" +
              props.setting_name
          );

          let value;

          if (selectedOption == null) {
            value = null;
          } else if (props.multi_select !== true) {
            value = selectedOption.value;
          } else {
            value = selectedOption.map((option) => option.value).join(",");
          }

          // Check feature gate before proceeding with update
          if (
            builder.displayFeatureGate(
              undefined,
              props.feature_gate_type,
              value
            )
          ) {
            builder.update([
              {
                object_type: props.object_type,
                object_id: props.object_id,
                setting_name: props.setting_name,
                value: value,
                skip_history: props.skip_history,
              },
            ]);

            if (props.callback) {
              props.callback(value, old_value);
            }
          }
        }}
      ></Select>
    </React.Fragment>
  );
};

export default VariantBuilderSettingSelect;
